import { Module } from 'vuex'

import { MatchedState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: MatchedState = {
  matcheds: [],
  total: 0,
  isMatchedsLoading: false,
}

export const matched: Module<MatchedState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
